import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function PlanRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const resolve = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'plans'), where('slug', '==', slug)));
        if (snap.empty) {
          setError('Plan not found.');
          return;
        }
        const plan = { id: snap.docs[0].id, ...snap.docs[0].data() };
        // Store the plan ID so TrainingPlans can auto-select it
        sessionStorage.setItem('selectedPlanId', plan.id);

        // Quick-checkout plans send visitors straight to mini-reg —
        // consistent with the Get Started routing on the training pages.
        if (plan.allowMiniReg === true && plan.planType !== 'recurring' && !auth.currentUser) {
          navigate(`/quick-checkout?plan=${plan.id}`, { replace: true });
          return;
        }

        if (!auth.currentUser) {
          // Not logged in — save slug so we can return here after auth
          sessionStorage.setItem('pendingPlanSlug', slug);
          navigate('/login', { replace: true });
          return;
        }

        navigate('/training-plans', { replace: true });
      } catch (e) {
        setError('Failed to load plan.');
      }
    };
    resolve();
  }, [slug, navigate]);

  if (error) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2 }}>
      <Typography variant="h5" color="error">{error}</Typography>
      <Typography variant="body2" sx={{ color: '#888' }}>The plan link may be invalid or expired.</Typography>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}
